module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-alert', {
    staticClass: "errors mb-4",
    attrs: {
      "color": "error"
    },
    model: {
      value: (_vm.hasErrors),
      callback: function($$v) {
        _vm.hasErrors = $$v
      },
      expression: "hasErrors"
    }
  }, _vm._l((_vm.errors), function(error, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(error))])
  })), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitRegistration()
      }
    }
  }, [_c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "solo": "",
      "label": "Entreprise",
      "required": ""
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "solo": "",
      "label": "Prénom",
      "required": ""
    },
    model: {
      value: (_vm.firstname),
      callback: function($$v) {
        _vm.firstname = $$v
      },
      expression: "firstname"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "solo": "",
      "label": "Nom",
      "required": ""
    },
    model: {
      value: (_vm.lastname),
      callback: function($$v) {
        _vm.lastname = $$v
      },
      expression: "lastname"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "solo": "",
      "label": "Email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "solo": "",
      "label": "Téléphone",
      "required": ""
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_vm._v("\n        Pour créer un compte sur Weview, vous devez accepter nos "), _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.agreementModal = true
      }
    }
  }, [_vm._v("Conditions Générales d'Utilisation")]), _vm._v(".\n      ")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "J'accepte les conditions d'utilisation"
    },
    model: {
      value: (_vm.agreement),
      callback: function($$v) {
        _vm.agreement = $$v
      },
      expression: "agreement"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "round": "",
      "large": "",
      "color": "info"
    }
  }, [_vm._v("\n          C'est parti\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.agreementModal),
      callback: function($$v) {
        _vm.agreementModal = $$v
      },
      expression: "agreementModal"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v("Conditions Générales d'Utilisation Weview")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.agreementModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('agreement-conditions')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12d66fa7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewRegistration.vue
// module id = 551
// module chunks = 1